<template>
 <div>
    <label v-if="!$parent.event.booths || !$parent.event.booths.length"><b>
       No booths in this event.</b>
    </label>
    <b-card-group deck class="booth_deck">
      <div v-for="booth in $parent.event.booths"
        class="card booth_card">
        <div style="width:100%;text-align:center;">
          <img style="max-width:100%;max-height:10rem;height:auto;vertical-align:middle;" :src="booth.banner">
          </img>
        </div>
        <div class="card-body">
          <h4 class="card-title">
            {{ booth.title }}
          </h4>
          <label v-if="booth.startep">
            <b>{{ datestring(booth) }} </b>
          </label>
          <div>
            <b-link v-if="booth.url" @click="openbio(booth.url)">
              <b>Click for More</b>
            </b-link>
          </div>
          <b-card-text v-if="booth.description" class="para">
            {{ booth.description }}
          </b-card-text>
          <div v-if="session_status($parent.event,booth) == 'ended'"
             style="color:red">
             The booth is closed.
          </div>
          <div v-if="session_status($parent.event,booth) == 'soon'">
            <div style="color:red"> Starting Soon </div>
            <div v-if="!$parent.registered"
               style="color:red">
               To join, please register in Reception.
            </div>
            <b-button :disabled="!$parent.registered"
               variant="success"
               @click="$parent.goto_room(booth.roomname)">
               Join
            </b-button>
          </div>
          <div v-if="session_status($parent.event,booth) == 'active'">
            <div v-if="!$parent.registered"
               style="color:red">
               To join, please register in Reception.
            </div>
            <b-button :disabled="!$parent.registered"
               variant="success"
               @click="$parent.goto_room(booth.roomname)">
               Join
            </b-button>
          </div>
        </div>
      </div>
    </b-card-group>
 </div>
</template>

<script>

import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import utils from "../eventutils";

export default {
  name: "booths",
  data() {
    return {
    }
  },
  components: {
  },
  created() {
  },
  methods: {
    datestring: utils.datestring,
    openbio: utils.openbio,
    session_status: utils.session_status,
  },
  computed: {
  },
  beforeDestroy() {
  },
  mounted() {
    let vue = this;
  },
};
</script>

<style lang="scss" scoped>
.booth_deck {
  justify-content: center;
  margin-right:0;
  margin-left:0;
}
.booth_card {
  min-width: 20rem;
  max-width: 30rem;
  min-height: 20rem;
  margin-top: 10px;
  margin-bottom: 10px;
}
.date_time {
  font-size:1.2rem;
  font-weight:500;
  text-align:left;
  color:black;
  padding-bottom: 1rem;
}
.para {
  white-space: pre-wrap;
} 
</style>
